/* eslint-disable @typescript-eslint/no-explicit-any */

import { StackedBarChart } from '../../types/StatTypes'
import ChartSkeleton from '../skeleton/ChartSkeleton'
import { useEffect, useId, useState } from 'react'
import BaseChart from './BaseChart'

interface IStackedBarProps {
  chartData: StackedBarChart
}

const StackedBar = (props: IStackedBarProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const { chartData } = props
  const chartId = useId()

  useEffect(() => {
    if (chartData) {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 300)
      return () => clearTimeout(timer)
    }
  }, [chartData])

  const options: any = {
    chart: {
      type: 'bar',
      height: '50px',
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
      min: 0,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        stacking: 'percent',
        dataLabels: {
          enabled: false,
        },
        groupPadding: 0,
        pointPadding: 0,
        borderWidth: 0,
      },
      bar: {
        borderRadius: 0,
      },
    },
    tooltip: {
      enabled: false,
    },
    series: chartData.series,
    credits: {
      enabled: false,
    },
  }

  return <>{isLoading ? <ChartSkeleton fullWidth={true} /> : <BaseChart options={options} id={chartId} />}</>
}

export default StackedBar
